{phoneValidator, emailValidator, requiredFieldValidator} = require 'utils/validations'
validator = require 'utils/validate'

App.SettingsStaffEditController = Em.Controller.extend
  session: Em.inject.service()

  staffBinding: 'model'

  sip_enabled: Em.computed.oneWay 'session.currentBilling.tariff_restrictions.sip_enabled'

  needs: [ 'settingsStaff' ]

  staffRole: Em.computed.oneWay('staff.role')
  sipFieldsDisabled: Ember.computed.not('staff.sip_enabled')

  restaurantsSortOrder: ['city','name']
  restaurants: Ember.computed.sort('controllers.settingsStaff.restaurants', 'restaurantsSortOrder')

  cookingLinesBinding: 'controllers.settingsStaff.cooking_lines'

  businessRolesBinding: 'controllers.settingsStaff.business_roles'

  isSaving: false
  env:   Em.inject.service('environment')
  session: Em.inject.service()

  cookingLinesEnabled: Em.computed.oneWay 'env.features.cookingLinesEnabled'

  isShowRoleSelect: Ember.computed 'staffRole', ->
    @get('staffRole') != 'admin'

  isMe: (->
    myId  = @get('session.currentUser._data.account.id')
    hisId = @get('staff.id')

    return false unless myId and hisId

    myId.toString() is hisId.toString()
  ).property(
    'session.currentUser._data.account.id',
    'session.currentUser.account.id',
    'staff.id')

  errors: {}

  actions:
    ###
    # Сохранить сотрудника
    ###
    saveStaff: ->
      staff = @get('staff')
      staff.set('role', @get('staffRole'))

      staffPhone = @get('staff.phone')
      staffLogin = @get('staff.login')

      currentErrors = validator.useValidation({
        phone: staffPhone,
        login: staffLogin
      }, ()=> ({
        phone: if !Ember.isEmpty(staffPhone) then phoneValidator(),
        login: [emailValidator(), requiredFieldValidator()]
      }))()
      @set('errors', currentErrors)
      return if Object.values(currentErrors).length

      @set('isSaving', true)

      if staff.get('isAdmin')
        staff.get('restaurants').pushObjects(@get('restaurants'))

      wasNew = staff.get('isNew')

      staff.save()
      .then (staff) =>
        if wasNew
          @transitionToRoute('settings.staff.show', staff.get('id'))
        else
          @send('goBackToStaffList')
      .catch =>
        false
      .finally =>
        @set('isSaving', false)

        # Разбираем ошибки валидации
        validationErrors = staff.get('errors')

        [ 'login', 'password', 'password_confirmation', 'name' ].forEach (field) =>
          validationField = "errors.#{field}"
          if validationErrors.has(field)
            message = validationErrors.errorsFor(field).map (m) ->
              m.message
            .join(',')

            @set(validationField, message)
          else
            @set(validationField, null)

      false

    ###
    # Удалить сотрудника
    ###
    deleteStaff: ->
      # todo i18n
      return unless confirm('Удалить сотрудника?')

      staff = @get('staff')

      staff.destroyRecord()
      .finally =>
        @send('goBackToStaffList')
      false

    ###
    # Отменить изменения
    ###
    cancel: ->
      # todo i18n
      return unless confirm('Отменить изменения?')

      staff = @get('staff')
      staff.rollback()

      @send('goBackToStaffList')
      false

    ###
    # Назад
    ###
    goBackToStaffList: ->
      @transitionToRoute('settings.staff')
      false
